import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { CustomFieldType } from '../types';

interface UpdateCustomFieldParams {
  customFieldId: number;
  categoryId: number;
  name: string;
  field_type: CustomFieldType;
  is_required: boolean;
  unit_name?: string | null;
  options?: string[];
}

/**
 * カスタムフィールド更新用のフック
 */
export default function useUpdateCustomField() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      customFieldId,
      categoryId,
      name,
      field_type,
      is_required,
      unit_name,
      options,
    }: UpdateCustomFieldParams) => {
      const response = await fetch(`/agent/api/custom_fields/${customFieldId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token':
            document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '',
        },
        body: JSON.stringify({
          custom_category_id: categoryId,
          name,
          field_type,
          is_required,
          unit_name,
          options,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.errors?.[0] || 'カスタムフィールドの更新に失敗しました');
      }

      return response.json();
    },
    onSuccess: (data, variables) => {
      // カテゴリ詳細のキャッシュを無効化して再取得
      queryClient.invalidateQueries({ queryKey: ['custom_category', variables.categoryId] });
    },
  });
}
